import { Backdrop, Card, CardContent, CardHeader, CircularProgress, Container, Divider, Snackbar, TextField, Button, Checkbox, FormControlLabel, Grid, InputAdornment, OutlinedInput, Typography, IconButton, DialogActions } from '@mui/material';
import EmployeeCard from 'src/components/cards/EmployeeCard';
import Alert from 'src/components/Alert';
import { useTheme } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useState, useEffect } from 'react';
import DirectionsIcon from '@mui/icons-material/Directions';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'src/utils/axios';
import MainCard from 'src/components/cards/MainCard';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import Profile from 'src/components/account-profile/Profile1';
import DialogTitle from '@mui/material/DialogTitle';
import ExcelFileCreator from 'src/components/ExcelFileCreator';
import ServiceProfileCard from 'src/components/ServiceProfileCard';
import Pagination from '@mui/material/Pagination';
import ServiceDetailCard from 'src/components/ServiceDetailCard';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const styles = {
    ul: {
        '& .MuiPaginationItem-root': {
            '&.Mui-selected': {
                background: '#FF9800',
                color: 'white',
                borderRadius: '50%',
            },
        },
    },
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }),
};

function ServiceManagement() {
    const { id: serviceManagementId } = useParams();
    const theme = useTheme();
    const [openEditPopUp, setOpenEditPopUp] = useState(false);
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const [loading, setLoading] = useState(false);
    const [Warning, setWarning] = useState(false);
    const [WarningType, setWarningType] = React.useState('default');
    const SessionUser = getUser();
    const [servicesData, setServicesData] = React.useState([]);
    const [services, setServices] = React.useState([]);
    const [isLoading, setisLoading] = useState(true);
    const [OrganizationIdParam, setOrganizationIdParam] = React.useState(0);
    const [imageDataList, setImageDataList] = useState([]);
    const [openEditPopUpEdit, setOpenEditPopUpEdit] = useState(false);
    // drawer
    const [open, setOpen] = useState(isLoading);
    const [selected, setSelected] = React.useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);

    const [OrganizationControl, setOrganizationControl] = React.useState(0);
    const [gridSpacing, setgridSpacing] = React.useState(3);
    const [responseMessage, setresponseMessage] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [EmployeeName, setEmployeeName] = useState("");
    const [EmployeeRole, setEmployeeRole] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search)
    const temp = params.get('IsRedirected');
    const IsRedirected = temp;

    const querySelectedBolge = params.get('SelectedBolge');
    const querySelectedServis = params.get('SelectedServis');
    const queryDialogOpen = params.get('DialogOpen');


    const [srcAktif, setsrcAktif] = useState(true);
    const [srcPasif, setsrcPasif] = useState(false);

    const [selectedService, setSelectedService] = useState(null);
    const [selectedServiceCover, setSelectedServiceCover] = useState(null);

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };




    const WarningClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setWarning(false);
    };
    const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
    const [BirimData, setBirimData] = React.useState([]);
    const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState(null);
    const [SelectedBirim, setSelectedBirim] = React.useState([]);
    const [OpenChangeList, setOpenChangeList] = React.useState(false);
    const [EmployeeNr, setEmployeeNr] = React.useState(0);
    const [NameParam, setNameParam] = React.useState('');
    const [SurnameParam, setSurnameParam] = React.useState('');
    const [role, setrole] = React.useState('');
    const [StatusId, setStatusId] = React.useState(0);
    const [loadingCombo, setLoadingCombo] = useState(true);
    const [OpenShowPopUp, setOpenShowPopUp] = React.useState(false);
    const [search, setSearch] = React.useState('');
    const [displayedServicesData, setDisplayedServicesData] = useState([]);
    const [selectedServiceName, setSelectedServiceName] = useState('');
    const [selectedServiceAddress, setSelectedServiceAddress] = useState('');



    useEffect(() => {
        // Remove the IsRedirected param
        if (IsRedirected) {
            params.delete('IsRedirected');
            navigate({ pathname: location.pathname, search: params.toString() });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [IsRedirected, params, navigate]);

    useEffect(() => {
        getBolgeAdiKoduData();
        setOrganizationControl(serviceManagementId);
        setisLoading(false);
        if (querySelectedServis) {
            setSelectedBirim(querySelectedServis);
        }
        if (queryDialogOpen) {
            setOpenEditPopUp(true);
        }
    }, []);

    useEffect(() => {
        if (selectedbolgeAdiKodu?.BirimKodu) {
            getDetail(selectedbolgeAdiKodu)
        }
    }, [selectedbolgeAdiKodu]);

    useEffect(() => {
        if (selectedbolgeAdiKodu?.BirimKodu) {
            getDetail(selectedbolgeAdiKodu, srcAktif, srcPasif);
        }
    }, [srcAktif, srcPasif]);

    useEffect(() => {
        if (querySelectedBolge) {
            const selectedBolge = bolgeAdiKodu.find((bolge) => bolge.BirimKodu === querySelectedBolge);
            if (selectedBolge) {
                setSelectedbolgeAdiKodu(selectedBolge);
            }
        }
    }, [bolgeAdiKodu]);

    const getBolgeAdiKoduData = () => {
        setLoadingCombo(true);
        axios.get(`GetTopServiceCode/${SessionUser.TopServiceShopCode}`).then((response) => {
            var Data = response.data;
            var newData = Data.filter((item) => item?.BirimKodu !== "0");
            setBolgeAdiKodu(newData);
            if (newData.length == 1) {
                setSelectedbolgeAdiKodu(newData[0])
                //add to query string "SelectedBolge" newdata[0].BirimKodu
                params.set('SelectedBolge', newData[0].BirimKodu);
                navigate({ pathname: location.pathname, search: params.toString() });
            }
            setLoadingCombo(false);
        }).catch((error) => {
            setLoadingCombo(false);
        });

    }

    const getDetail = (value) => {
        setLoading(true);
        setSearch("");


        const endpoint = `GetServiceProfileData/${selectedbolgeAdiKodu.BirimKodu}/${srcAktif}/${srcPasif}/0`;

        axios
            .get(endpoint)
            .then((response) => {
                setLoading(false);
                if (response.data.length > 0) {
                    setServices(response.data);
                    setServicesData(response.data);
                    setDisplayedServicesData(response.data);
                } else {
                    setServices([]);
                    setServicesData([]);
                }
            })
            .catch((error) => {
                setLoading(false);
            });
    }


    const handleSearch = async (event) => {
        const newString = event?.target.value;
        setSearch(newString);

        if (newString) {
            const lowercasedNewString = newString.toLowerCase('tr-TR');

            const filteredData = servicesData.filter(item => {
                // Check for undefined or null values

                const concatenatedStr = `${item.ACIKLAMA ?? ''} ${item.KUL_BIRIM_KODU ?? ''} ${item.NAME ?? ''} ${item.SERVIS_SAHIBI ?? ''} ${item.EMAIL ?? ''} ${item.TELEFON ?? ''} ${item.SEHIR ?? ''} ${item.SERVIS_TIP ?? ''}`;
                const lowercasedConcatenatedStr = concatenatedStr.toLowerCase('tr-TR');
                return lowercasedConcatenatedStr.includes(lowercasedNewString);
            });
            setDisplayedServicesData(filteredData);
        } else {
            setDisplayedServicesData(servicesData);
        }
    };


    const SetChangeList = () => {
        if (OpenChangeList === false) {
            setOpenChangeList(true);
        } else {
            setOpenChangeList(false);
        }
    };


    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            if (selected.length > 0) {
                setSelected([]);
            } else {
                const newSelectedId = services.map((n) => n.name);
                setSelected(newSelectedId);
            }
            return;
        }
        setSelected([]);
    };

    const handleClickTable = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }

        setSelected(newSelected);
    };

    const handleActiveChange = (event) => {
        const isChecked = event.target.checked;
        setsrcAktif(isChecked);
    };



    const handlePassiveChange = (event) => {
        const isChecked = event.target.checked;
        setsrcPasif(isChecked);
    };



    const isSelected = (name) => selected.indexOf(name) !== -1;

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - services.length) : 0;

    const handleExportClick = () => {
        var kulBirimKoduAdi = "";
        kulBirimKoduAdi = SelectedBirim?.Dsc

        var excelData = [];
        services?.map((item) => {
            var data = {
                "Eleman No": item.id,
                "Adı Soyadı": item.name.split('-')[1].trim(),
                "Çalışan Tipi": item.role,
                "Hakkında": item.about,
                "Email": item.email,
                "Telefon": item.contact.replace(/[^0-9]/g, ''),
                "İl": item.location,
                "Durum": item.status,
            }
            excelData.push(data);
        })
        ExcelFileCreator(excelData, `${kulBirimKoduAdi} Çalışan Listesi`);
    };


    const NewEmployeeGet1 = (EmployeeNrParam) => {
        setOpenEditPopUp(false);
        setEmployeeNr(EmployeeNrParam);
        setOpenEditPopUpEdit(true);
    }


    const setEmployeeNew = () => {
        if (OrganizationIdParam === undefined || OrganizationIdParam === 0 || OrganizationIdParam === "") {
            setWarningType("error");
            if (OrganizationControl === "1") {
                setresponseMessage("Lütfen Servis Seçiniz!...");
            } else {
                setresponseMessage("Lütfen Bayi Seçiniz!...");
            }
            setWarning(true);
        } else {
            setOpenEditPopUp(true);
        }
    }

    const setOpenEditPopUpEditParam = (EmployeeNr, OrganizationTypeId, OrganizationId,
        NameParam, SurnameParam, role, StatusId) => {
        setEmployeeNr(EmployeeNr);
        setNameParam(NameParam);
        setSurnameParam(SurnameParam);
        setrole(role);
        setStatusId(StatusId);
        setOpenEditPopUpEdit(true);
    }

    const setOpenShowPopUpParam = (EmployeeNr, EmployeeName, EmployeeRole) => {
        setEmployeeNr(EmployeeNr);
        setEmployeeName(EmployeeName);
        setEmployeeRole(EmployeeRole);
        setOpenShowPopUp(true);
    }

    const handleQuery = () => {
        setLoading(true);
        const endpoint = `GetServiceProfileData/${0}/${srcAktif}/${srcPasif}/${search}`;
        axios
            .get(endpoint)
            .then((response) => {
                setLoading(false);
                if (response.data.length > 0) {
                    setServices(response.data);
                    setServicesData(response.data);
                    setDisplayedServicesData(response.data);
                } else {
                    setServices([]);
                    setServicesData([]);
                    setDisplayedServicesData([]);
                }
            })
            .catch((error) => {
                setLoading(false);
            });
    }



    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleSetSelectedService = (service) => {
        setSelectedBirim(service);
        //add to query string "SelectedServis" service.id
        params.set('SelectedServis', service);
        navigate({ pathname: location.pathname, search: params.toString() });

    };

    const handleSetOpenEditPopUp = (value) => {
        setOpenEditPopUp(value);
        params.set('DialogOpen', value);
        navigate({ pathname: location.pathname, search: params.toString() });
    }




    return (
        <Page>
                <Backdrop open={loading} style={{ zIndex: 9999 }}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar
                    open={Warning}
                    autoHideDuration={10000}
                    onClose={WarningClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={WarningClose} variant={WarningType} message={responseMessage}></Alert>
                </Snackbar>
                <br />
                <Container maxWidth="xl">
                    <Card>
                        <CardHeader
                            title={<Typography variant="h4">Servis Yönetimi</Typography>}
                        />
                        <Divider />
                        <CardContent>
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        lg: 6
                                    }}>
                                    <Autocomplete
                                        size="small"
                                        id="combo-box-demo"
                                        fullWidth
                                        value={selectedbolgeAdiKodu}
                                        options={bolgeAdiKodu}
                                        getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                                        onChange={(event, newValue) => {
                                            setSelectedbolgeAdiKodu(newValue);
                                            params.set('SelectedBolge', newValue.BirimKodu);
                                            navigate({ pathname: location.pathname, search: params.toString() });
                                            setServices([]);
                                            setServicesData([]);
                                        }}
                                        loading={loadingCombo}
                                        renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {loadingCombo && <CircularProgress color="primary" size={20} />}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }} />}
                                    />
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        lg: 6
                                    }}>
                                    <OutlinedInput
                                        fullWidth
                                        id="input-search-card-style1"
                                        placeholder="Arama"
                                        value={search}
                                        onChange={handleSearch}
                                        autoComplete="off"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <SearchIcon stroke={1.5} size="16px" />
                                            </InputAdornment>
                                        }
                                        endAdornment={  // Yeni kısım: Sorgulama butonu
                                            <InputAdornment position="end">
                                                <IconButton color="primary" onClick={handleQuery}>
                                                    <DirectionsIcon stroke={1.5} />
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        size="small"
                                    />
                                </Grid>
                                <Grid
                                    style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                                    size={{
                                        xs: 12,
                                        sm: 3
                                    }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={srcAktif}
                                                onChange={handleActiveChange}
                                                style={{ color: 'green' }}
                                                name="Aktif"
                                            />
                                        }
                                        label="Aktif"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={srcPasif}
                                                onChange={handlePassiveChange}
                                                style={{ color: 'red' }}
                                                name="Pasif"
                                            />
                                        }
                                        label="Pasif"
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <br />
                    <MainCard>
                        <Grid container direction="row" spacing={gridSpacing}>
                            {displayedServicesData.length > 0 && displayedServicesData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((row, index) => (
                                <Grid
                                    key={index}
                                    size={{
                                        xs: 12,
                                        sm: 3
                                    }}>
                                    <ServiceProfileCard
                                        avatar={row.SERVIS_SAHIBI_RESIM}
                                        name={row.ACIKLAMA}
                                        role={row.NAME}
                                        status={row.BUYUKLUK_KONUMU}
                                        profile={row.SERVIS_SAHIBI_RESIM}
                                        type={`${row.ACIKLAMA.toLocaleLowerCase('tr-TR').includes('nakliye montaj') 
                                            ? `${row.SERVIS_TIP} - Nakliye Montaj`
                                            : row.SERVIS_TIP}${row.MERKEZ_SUBE === 0 ? ' - Şube' : ''}`}
                                        email={row.EMAIL}
                                        phone={row.TELEFON}
                                        location={row.SEHIR}
                                        openDate={row.ACILIS_TARIHI}
                                        address={row.ADRES}
                                        id={row.id}
                                        personelCount={row.ServiceShopTotalEmployee}
                                        vehicleCount={row.ServiceShopTotalVehicle}
                                        setOpenEditPopUp={handleSetOpenEditPopUp}
                                        setSelectedServiceName={setSelectedServiceName}
                                        setSelectedBirim={handleSetSelectedService}
                                        setSelectedServiceAddress={setSelectedServiceAddress}
                                        Avatar3={row.SERVIS_RESIM}
                                        onClick={() => {
                                            setSelectedServiceCover(row.SERVIS_RESIM);
                                            setOpenEditPopUp(true);
                                            setSelectedBirim(row.id);
                                            setSelectedServiceName(row.ACIKLAMA);
                                            setSelectedServiceAddress(row.ADRES);
                                            // ...diğer gerekli state güncellemeleri...
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        <Pagination
                            count={Math.ceil(servicesData.length / itemsPerPage)}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            color="primary"
                            sx={styles.ul}
                            style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
                        />
                    </MainCard>
                </Container>
                <Dialog
                    fullScreen
                    open={openEditPopUp}
                    onClose={() => setOpenEditPopUp(false)}
                    style={{ marginTop: -10 }}
                >
                    <DialogTitle
                        size="small"
                        id="responsive-dialog-title"
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        Servis Detayı
                        <IconButton
                            edge="end"
                            size="small"
                            color="inherit"
                            onClick={() => setOpenEditPopUp(false)}
                            aria-label="close"
                            sx={{
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent >
                        <ServiceDetailCard
                            ServiceShopId={SelectedBirim}
                            ServiceShopName={selectedServiceName}
                            IsRedirected={IsRedirected}
                            ServiceShopAddress={selectedServiceAddress}
                            TopServiceShopCode={selectedbolgeAdiKodu?.BirimKodu}
                            EmployeeRole={EmployeeRole}
                            Cover={selectedServiceCover}
                        />
                    </DialogContent>
                </Dialog>
                <Dialog
                    fullScreen
                    open={openEditPopUpEdit}
                    sx={{ '& .MuiDialog-paper': { maxHeight: 800, minHeight: 800 } }}
                    onClose={() => setOpenEditPopUpEdit(false)}

                >
                    <DialogTitle
                        size="small"
                        id="responsive-dialog-title"
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        Çalışan Detayı
                        <IconButton
                            edge="end"
                            size="small"
                            color="inherit"
                            onClick={() => setOpenEditPopUpEdit(false)}
                            aria-label="close"
                            sx={{
                                position: 'absolute',
                                top: '50%', // Yukarıdan %50 konumda
                                right: '500px', // Sağ kenarda
                                transform: 'translateY(-50%)', // Dikey ortalamayı sağlar
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Profile EmployeeNr={EmployeeNr}
                            OrganizationTypeId={OrganizationControl}
                            ServiceShopId={OrganizationIdParam}

                            Name={NameParam}
                            Surname={SurnameParam}
                            PersonelType={role}
                            StateId={StatusId} />
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={OpenShowPopUp}
                    onClose={() => setOpenShowPopUp(false)}>
                    <EmployeeCard EmployeeNr={EmployeeNr} EmployeeName={EmployeeName} EmployeeRole={EmployeeRole} />
                    <DialogActions>
                        <Button onClick={() => setOpenShowPopUp(false)} autoFocus>
                            Kapat
                        </Button>
                    </DialogActions>
                </Dialog>

        </Page >
    );
}

export default ServiceManagement;
